export const TabsEnum = {
    SUMMARY: "customSummary",
    OVERVIEW: "overview",
    TRANSACTION: "transactions",
    IRREGULARITIES: "suspiciousActivities",
    AMLANALYSIS: "amlAnalysis",
    MONTHLYSUMMARY: "txnsSummary",
    UPITXNANALYSIS: "upiTxnsAnalysis",
    DAILYBALANCE: "dailyBalance",
    BOUNCEDCHEQUES: "bouncedCheque",
    SALARY: "salary",
    CATEGORIES: "categories",
    CASHFLOW: "cashFlow",
    CASHFLOWANALYSIS: "cashFlowAnalysis",
    BUSINESSCASHFLOW: "bizCashFlow",
    COUNTERPARTY: "counterParty",
    MONTHLYCOUNTERPARTY: "monthlyCounterParty",
    RECURRINGPAYMENTS: "recurringPayments",
    EMIPAYMENT: "EMIPayments",
    LOANANALYSIS: "loanAnalysis",
    LOAN: "loans",
    AVAILABLEBALANCE: "closingBalance",
    DUPLICATETRANSACTION: "duplicateTxns",
    CIRCULARTRANSACTION: "circularTransactions",
    INTRABANKTRANSFER: "intraBankFundTransfer",
    ODCCUTILIZATION: "ODCCUtilization",
    RECURRINGDEPOSIT: "recurringDeposits"
}